import { request } from './utils';

export default class LenderService {
    static async getActive() {
        const response = await request('/api/lenders/active');
        // P4 returns { lenders: [...] }; call-sites expect the bare array
        // (DPP used to unwrap this).
        return response.data?.lenders;
    }
}
